module.exports = __webpack_public_path__ + "img/w3_circle_up_light.93f35d2d.93f35d2d.png";